// import ProfileComp from './ProfileComp/'
import NewProfileNative from './ProfileComp/'

const ProfileMobile = () => {
  return <NewProfileNative />
}

export default ProfileMobile
